import { RunSettingsActive } from '../RunSettingsHandler';
import { RunSettingsOverride } from '../RunSettingsOverride';

export const RelicName = {
  None: 'none',
  BronzeBoots: 'bronzeBoots',
  DiamondSkull: 'diamondSkull',
  GoldenWings: 'goldenWings',
  PlatinumMagnet: 'platinumMagnet',
  SilverHelmet: 'silverHelmet'
} as const;
export type RelicNameKeys = keyof typeof RelicName;
export type RelicNameValues = typeof RelicName[RelicNameKeys];

export class RelicEffect extends RunSettingsOverride {}

export class RelicEffectBronzeBoots extends RelicEffect {
  public override(runSettingsActive: RunSettingsActive): void {
    runSettingsActive.maxAirJumps = 2;
  }
}

export class RelicEffectWings extends RelicEffect {
  public override(runSettingsActive: RunSettingsActive): void {
    runSettingsActive.glideTime = 1500.0;
  }
}

export class RelicEffectMagnet extends RelicEffect {
  public override(runSettingsActive: RunSettingsActive): void {
    runSettingsActive.magnetStrength = 300;
  }
}

export class RelicEffectHelmet extends RelicEffect {
  public override(runSettingsActive: RunSettingsActive): void {
    runSettingsActive.canBreakAllSmashables = true;
  }
}

export class RelicEffectSkull extends RelicEffect {
  public override(runSettingsActive: RunSettingsActive): void {
    runSettingsActive.startingContinueTokens = 1;
    runSettingsActive.continueTokens = 1;
  }
}

export const relicSettingsOverrideLookup: { [key in RelicNameValues as string]: RunSettingsOverride } = {
  [RelicName.GoldenWings]: new RelicEffectWings(),
  [RelicName.DiamondSkull]: new RelicEffectSkull(),
  [RelicName.BronzeBoots]: new RelicEffectBronzeBoots(),
  [RelicName.SilverHelmet]: new RelicEffectHelmet(),
  [RelicName.PlatinumMagnet]: new RelicEffectMagnet()
};
